import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-medal"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "" }, [
      _createElementVNode("path", {
        d: "M27.3,23.6c0,0.1,0,0.1,0,0.2v12.2\n\t\tL22,32.1l-5.3,3.8V23.8c0-0.1,0-0.1,0-0.2",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("circle", {
        cx: "22",
        cy: "16.7",
        r: "8.7",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("circle", {
        cx: "22",
        cy: "16.7",
        r: "4.8",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }